<rt-gauge-chart [value]="positiveRatings!"></rt-gauge-chart>

<div class="text-wrap" layout-vertical layout-justify-center>
  <div class="evaluation-label" text-bold>
    {{ evaluationTranslationKey | translate }}
  </div>
  <span
    [innerHTML]="
      'app.interview.summary.overall_info'
        | translate: { totalRatings: totalRatings, uniqAdmins: uniqAdmins }
    "
  ></span>
  @if (lastUpdate) {
    <div class="light">
      {{ 'app.interview.summary.overall_last_submitted' | translate }}
      {{ lastUpdate | rtTimeAgoAsync }}
    </div>
  }
</div>
